export default "__VITE_ASSET__DH$W1JfT__"